import { Flex, Switch, Text, VStack } from '@chakra-ui/react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { FormWidgetData } from 'widgets/FormWidget/FormWidget.types';
import { useWidget } from 'widgets/sdk';

import SelectionFieldOptions from './SelectionFieldOptions';
import SelectionFieldQuestion from './SelectionFieldQuestion';

export const SelectionFieldSection = ({ isLabelFocused = false }) => {
  const { t } = useTranslation('editor_widget_toolbar', {
    keyPrefix: 'formToolbar.settingsSideBar.question',
    useSuspense: false,
  });
  const { updateWidget, selectionFieldData } = useWidget<FormWidgetData>();
  const flag = !!selectionFieldData?.enableMultipleSelection;

  // Toggle between Radio <-> Checkbox component
  const handleSwitchChange = useCallback(() => {
    // Update side setting toolbar state
    updateWidget({
      selectionFieldData: {
        enableMultipleSelection: !flag,
      },
    });
  }, [flag, updateWidget]);

  return (
    <VStack spacing={4} px={4}>
      <SelectionFieldQuestion isLabelFocused={isLabelFocused} />
      <Flex w={'full'} textAlign={'left'} justifyContent='space-between'>
        <Text fontSize={'sm'} fontWeight='bold' my={2} textAlign={'left'}>
          {t('options')}
        </Text>
        <Flex flexDir='row' alignItems='center'>
          <Text fontSize='sm'>{t('multipleSelection')}</Text>
          <Switch size='md' pl={4} isChecked={flag} onChange={handleSwitchChange} />
        </Flex>
      </Flex>

      <SelectionFieldOptions />
    </VStack>
  );
};
